import classNames from "classnames";
import { ProfileCalendar } from "PFApp/booking/types";
import { Profile } from "PFTypes";
import React from "react";

import bookingCalendarCss from "../../../booking_calendars.module.scss";
import { TrashIcon } from "../../icons";
import css from "../workforce.module.scss";

type UnassignCalendarsCellProps = {
  profileCalendars: ProfileCalendar[];
  profile: Profile;
  onUnassign: (params: { profileId: number; profileCalendar: ProfileCalendar }) => void;
};

export const UnassignCalendarsCell = ({
  profileCalendars,
  profile,
  onUnassign
}: UnassignCalendarsCellProps) => (
  <div className={bookingCalendarCss.calendarsGridCell}>
    {profileCalendars.map((profileCalendar, index) => (
      <TrashIcon
        key={index}
        className={classNames(css.cellEntry, css.clickable)}
        width={20}
        height={20}
        onClick={() => onUnassign({ profileId: profile.id, profileCalendar })}
      />
    ))}
  </div>
);
